"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsPrebid = void 0;
var utils_1 = require("../utils/utils");
var log_1 = require("../utils/log");
var Analytics_1 = require("./Analytics");
var __1 = require("..");
var Page_1 = require("./Page");
var AnalyticsPrebid = /** @class */ (function () {
    function AnalyticsPrebid() {
        this.impression_data = {};
        // impression request queue
        this.impression_queue = [];
        this.impression_queue_timer = null;
        // viewability request queue
        this.viewability_queue = [];
        this.viewability_queue_timer = null;
        try {
            globalThis.googletag.cmd.push(function () {
                this.prebidBidWon();
                this.gamSlotRenderEnded();
                this.gamImpressionViewable();
            }.bind(this));
        }
        catch (error) {
            (0, log_1.logError)(error);
        }
    }
    AnalyticsPrebid.prototype.prebidBidWon = function () {
        globalThis.pbjs.onEvent('bidWon', function (winningBid) {
            var _a, _b;
            var pbjsWinningBids = globalThis.pbjs.getAllWinningBids();
            var slotAdUnitCode = winningBid.adUnitCode;
            var allbids = globalThis.pbjs.getBidResponses();
            var slotBids = ((_a = allbids[slotAdUnitCode]) === null || _a === void 0 ? void 0 : _a.bids) || [];
            if (!this.impression_data[slotAdUnitCode]) {
                this.impression_data[slotAdUnitCode] = {
                    refresh_count: 0
                };
            }
            else {
                this.impression_data[slotAdUnitCode].refresh_count++;
            }
            this.impression_data[slotAdUnitCode].impression_id = (0, utils_1.generateUUID)(),
                this.impression_data[slotAdUnitCode].page_id = Page_1.globalPage.id;
            var slotName = slotAdUnitCode;
            try {
                var slot = globalThis.googletag.pubads().getSlots().find(function (slot) {
                    return slot.getSlotElementId() == slotAdUnitCode;
                });
                if (slot && slot.getAdUnitPath()) {
                    slotName = slot.getAdUnitPath().split('/').pop() || slot.getAdUnitPath();
                }
            }
            catch (error) {
                (0, log_1.logWarn)(error);
            }
            // loop through slotBids and get highest bidObj by bid.cpm
            var nextHighestBid = null;
            var _loop_1 = function (i) {
                var bid = slotBids[i];
                if (!nextHighestBid) {
                    nextHighestBid = bid;
                }
                else if (!pbjsWinningBids.find(function (winner) {
                    return winner.adId == bid.adId;
                }) &&
                    bid.cpm > nextHighestBid.cpm) {
                    nextHighestBid = bid;
                }
            };
            for (var i = 0; i < slotBids.length; i++) {
                _loop_1(i);
            }
            var floor = ((_b = winningBid === null || winningBid === void 0 ? void 0 : winningBid.floorData) === null || _b === void 0 ? void 0 : _b.floorValue) || 0;
            var min_bid_to_win = ((nextHighestBid === null || nextHighestBid === void 0 ? void 0 : nextHighestBid.cpm) || floor) + 0.01;
            var bidObj = {
                "page_id": (0, utils_1.validateValue)(this.impression_data[slotAdUnitCode].page_id, 'string', '', 256),
                "slot_id": (0, utils_1.validateValue)(slotName, 'string', '', 256),
                "impression_id": (0, utils_1.validateValue)(this.impression_data[slotAdUnitCode].impression_id, 'string', '', 256),
                // "auction_id": validateValue(winningBid?.auctionId, 'string', '', 256),
                "refresh_count": (0, utils_1.validateValue)(this.impression_data[slotAdUnitCode].refresh_count, 'number', 0, 99),
                "ad_bidder": (0, utils_1.validateValue)(winningBid === null || winningBid === void 0 ? void 0 : winningBid.bidder, 'string', '', 256),
                "ad_size": (0, utils_1.validateValue)(winningBid === null || winningBid === void 0 ? void 0 : winningBid.size, 'string', '', 256),
                "ad_price": (0, utils_1.validateValue)(winningBid === null || winningBid === void 0 ? void 0 : winningBid.cpm, 'number', 0, 99),
                "ad_floor_price": (0, utils_1.validateValue)(floor, 'number', '', 99),
                "min_bid_to_win": (0, utils_1.validateValue)(min_bid_to_win, 'number', 0, 99),
                // "ad_impid": validateValue(bidObj.data.impid, 'string', '', 256),
                "ad_adid": (0, utils_1.validateValue)(winningBid === null || winningBid === void 0 ? void 0 : winningBid.adId, 'string', '', 256),
                "ad_cid": (0, utils_1.validateValue)('', 'string', '', 256),
                "ad_crid": (0, utils_1.validateValue)(winningBid === null || winningBid === void 0 ? void 0 : winningBid.creativeId, 'string', '', 256),
                // "ad_dealid": validateValue(bidObj.data.dealid, 'string', '', 256),
                "ad_demand_type": (0, utils_1.validateValue)(winningBid === null || winningBid === void 0 ? void 0 : winningBid.mediaType, 'string', '', 256),
                "browser_timestamp": (0, utils_1.validateValue)((0, utils_1.getISOTimestamp)(), 'string', '', 256),
            };
            if (bidObj) {
                this.sendImpressionAnalytics(bidObj);
            }
        }.bind(this));
    };
    AnalyticsPrebid.prototype.gamSlotRenderEnded = function () {
        var _this = this;
        globalThis.googletag.pubads().addEventListener("slotRenderEnded", (function (event) {
            var advertiser = __1.globalSettings.gam_advertiser_ids[event.advertiserId];
            if (event.isEmpty || advertiser == 'prebid_ads')
                return;
            var slot = event.slot;
            if (slot && slot.getSlotElementId()) {
                var slotName = slot.getAdUnitPath().split('/').pop() || slot.getAdUnitPath();
                var slotElementId = slot.getSlotElementId();
                var gam_targeting = globalThis.pbjs.getAdserverTargeting() || {};
                if (!_this.impression_data[slotElementId]) {
                    _this.impression_data[slotElementId] = {
                        refresh_count: 0
                    };
                }
                else {
                    _this.impression_data[slotElementId].refresh_count++;
                }
                _this.impression_data[slotElementId].impression_id = (0, utils_1.generateUUID)(),
                    _this.impression_data[slotElementId].page_id = Page_1.globalPage.id;
                var slot_gam_targeting = gam_targeting[slotElementId] || {};
                var ad_price = (Number((slot_gam_targeting === null || slot_gam_targeting === void 0 ? void 0 : slot_gam_targeting.hb_pb) || (slot.getTargeting('hb_pb') || [])[0]) || 0) + 0.01;
                var floor = ad_price || 0;
                var min_bid_to_win = (ad_price || floor) + 0.01;
                var demand_type = (slot_gam_targeting === null || slot_gam_targeting === void 0 ? void 0 : slot_gam_targeting.hb_format) || (slot.getTargeting('hb_format') || [])[0] || 'banner';
                var amznbid = (slot.getTargeting('amznbid') || [])[0] || '';
                var amznp = (slot.getTargeting('amznp') || [])[0] || '';
                var bidObj = {
                    "page_id": (0, utils_1.validateValue)(_this.impression_data[slotElementId].page_id, 'string', '', 256),
                    "slot_id": (0, utils_1.validateValue)(slotName, 'string', '', 256),
                    "impression_id": (0, utils_1.validateValue)(_this.impression_data[slotElementId].impression_id, 'string', '', 256),
                    // "auction_id": validateValue(winningBid?.auctionId, 'string', '', 256),
                    "refresh_count": (0, utils_1.validateValue)(_this.impression_data[slotElementId].refresh_count, 'number', 0, 99),
                    "ad_bidder": (0, utils_1.validateValue)(advertiser, 'string', '', 256),
                    "ad_size": (0, utils_1.validateValue)(event.size.join('x'), 'string', '', 256),
                    "ad_price": (0, utils_1.validateValue)(ad_price, 'number', 0, 99),
                    "ad_floor_price": (0, utils_1.validateValue)(floor, 'number', 0, 99),
                    "min_bid_to_win": (0, utils_1.validateValue)(min_bid_to_win, 'number', 0, 99),
                    // "ad_impid": validateValue(bidObj.data.impid, 'string', '', 256),
                    "ad_adid": (0, utils_1.validateValue)(event.advertiserId, 'string', '', 256),
                    "ad_cid": (0, utils_1.validateValue)(event.campaignId, 'string', '', 256),
                    // "ad_crid": validateValue(winningBid?.creativeId, 'string', '', 256),
                    // "ad_dealid": validateValue(bidObj.data.dealid, 'string', '', 256),
                    "ad_amznbid": (0, utils_1.validateValue)(amznbid, 'string', '', 256),
                    "ad_amznp": (0, utils_1.validateValue)(amznp, 'string', '', 256),
                    "ad_demand_type": (0, utils_1.validateValue)(demand_type, 'string', '', 256),
                    "browser_timestamp": (0, utils_1.validateValue)((0, utils_1.getISOTimestamp)(), 'string', '', 256),
                };
                if (bidObj) {
                    _this.sendImpressionAnalytics(bidObj);
                }
            }
        }).bind(this));
    };
    AnalyticsPrebid.prototype.gamImpressionViewable = function () {
        globalThis.googletag.pubads().addEventListener("impressionViewable", function (event) {
            var slot = event.slot;
            if (slot && slot.getSlotElementId()) {
                var slotName = slot.getAdUnitPath().split('/').pop() || slot.getAdUnitPath();
                var slotElementId = slot.getSlotElementId();
                console.log("Impression for slot", slotElementId, "became viewable.");
                var viewabilityObj = {
                    'page_id': (0, utils_1.validateValue)(this.impression_data[slotElementId].page_id, 'string', '', 256),
                    'slot_id': (0, utils_1.validateValue)(slotName, 'string', '', 256),
                    'impression_id': (0, utils_1.validateValue)(this.impression_data[slotElementId].impression_id, 'string', '', 256),
                    'browser_timestamp': (0, utils_1.validateValue)((0, utils_1.getISOTimestamp)(), 'string', '', 256),
                };
                this.sendAdViewabilityAnalytics(viewabilityObj);
            }
        }.bind(this));
    };
    /**
     * Send impression data to server
     */
    AnalyticsPrebid.prototype.sendImpressionAnalytics = function (bidObj) {
        var _this = this;
        if (this.impression_queue_timer) {
            clearTimeout(this.impression_queue_timer);
        }
        // add bid to queue
        this.impression_queue.push(bidObj);
        // set a timer to queue more impressions and then send request when timer is up
        this.impression_queue_timer = setTimeout(function () {
            var impressions = _this.impression_queue;
            _this.impression_queue = [];
            Analytics_1.Analytics.sendAnalyticsRequest('https://analytics-cf.bigcrunch.com/impression/prebid', {
                'property_id': (0, utils_1.validateValue)(__1.globalSettings.property_id, 'string', '', 256),
                'impressions': impressions
            }).then(function () {
                (0, log_1.logInfo)('prebid impressions logged');
            }).catch(function (error) {
                (0, log_1.logError)(error);
            });
        }, this.impression_queue.length == 1 ? 500 : 250);
    };
    AnalyticsPrebid.prototype.sendAdViewabilityAnalytics = function (viewabilityObj) {
        var _this = this;
        if (this.viewability_queue_timer) {
            clearTimeout(this.viewability_queue_timer);
        }
        // add bid to queue
        this.viewability_queue.push(viewabilityObj);
        // set a timer to queue more impressions and then send request when timer is up
        this.viewability_queue_timer = setTimeout(function () {
            var viewability = _this.viewability_queue;
            _this.viewability_queue = [];
            Analytics_1.Analytics.sendAnalyticsRequest('https://analytics-cf.bigcrunch.com/viewability/prebid', {
                'property_id': (0, utils_1.validateValue)(__1.globalSettings.property_id, 'string', '', 256),
                'viewability': viewability
            }).then(function () {
                (0, log_1.logInfo)('viewability logged');
            }).catch(function (error) {
                (0, log_1.logError)(error);
            });
        }, this.viewability_queue.length == 1 ? 500 : 250);
    };
    return AnalyticsPrebid;
}());
exports.AnalyticsPrebid = AnalyticsPrebid;
